import { ALGOSENSEI_VIDEO, ALGOSENSEI_IMAGES, ALGOSENSEI_FEATURES, ALGOSENSEI_TAGS } from '../../../constants';
import { ProjectModal } from './ProjectModal';

export const AlgoSenseiModal = ({ isOpen, onClose, onOpenLightbox }) => (
  <ProjectModal
    isOpen={isOpen}
    onClose={onClose}
    number="02"
    title="AlgoSensei"
    category="AI learning tool"
    role="Full-Stack Developer"
    status="Completed school project"
    summary="An AI-powered mentor for learning data structures and algorithms through guided explanations and interactive visual examples."
    features={ALGOSENSEI_FEATURES}
    tags={ALGOSENSEI_TAGS}
    video={ALGOSENSEI_VIDEO}
    poster={ALGOSENSEI_IMAGES[2]}
    images={ALGOSENSEI_IMAGES}
    onOpenLightbox={onOpenLightbox}
    theme="coral"
  />
);
